import React from 'react';

import styled from 'styled-components';

import { CommunityReviewAlertScope } from './constants';

const TabsRow = styled.div`
  display: flex;
  column-gap: 12px;
`;

const TabButton = styled.button`
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
  border: none;
  padding: 4px 10px;
  border-radius: 100px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  font-size: 12px;
  cursor: pointer;
  background-color: var(--white);
  color: var(--text-primary);

  &.active {
    background-color: var(--button-blue);
    color: var(--white);
  }
`;

const TabStatus = styled.span`
  color: var(--text-secondary);
  font-size: 10px;

  &.on {
    color: var(--positive-green);
  }
`;

type AlertFlags = Record<CommunityReviewAlertScope, boolean>;

type Props = {
  activeTab: CommunityReviewAlertScope;
  alertFlags: AlertFlags;
  onTabClick: (tab: CommunityReviewAlertScope) => void;
};

const CommunityReviewAlertsTabs = ({ activeTab, alertFlags, onTabClick }: Props) => {
  return (
    <TabsRow>
      <TabButton
        type="button"
        className={activeTab === CommunityReviewAlertScope.COMMUNITY ? 'active' : ''}
        onClick={() => onTabClick(CommunityReviewAlertScope.COMMUNITY)}
      >
        This Community
        {activeTab !== CommunityReviewAlertScope.COMMUNITY && (
          <TabStatus className={alertFlags[CommunityReviewAlertScope.COMMUNITY] ? 'on' : ''}>
            {alertFlags[CommunityReviewAlertScope.COMMUNITY] ? 'On' : 'Off'}
          </TabStatus>
        )}
      </TabButton>
      <TabButton
        type="button"
        className={activeTab === CommunityReviewAlertScope.COMPETITOR ? 'active' : ''}
        onClick={() => onTabClick(CommunityReviewAlertScope.COMPETITOR)}
      >
        Competitors
        {activeTab !== CommunityReviewAlertScope.COMPETITOR && (
          <TabStatus className={alertFlags[CommunityReviewAlertScope.COMPETITOR] ? 'on' : ''}>
            {alertFlags[CommunityReviewAlertScope.COMPETITOR] ? 'On' : 'Off'}
          </TabStatus>
        )}
      </TabButton>
    </TabsRow>
  );
};

export default CommunityReviewAlertsTabs;
